const ProsperoPostType = Object.freeze({
  FB_COMMENT: 'FBComment',
  FB_LIKE: 'FBLike',
  FB_POST: 'FBPost',
  TW_ORIGINAL: 'TWOriginal',
  TW_RETWEETS: 'TWRetweets',
  TW_REPLIES: 'TWReplies',
  FM_ORIGINAL: 'FMOriginal',
  IT_MEDIA: 'ITMedia',
  IT_COMMENT: 'ITComment',
  FM_REPLIES: 'FMReplies',
  TM_ORIGINAL: 'TMOriginal',
  TM_REBLOGS_W_COMMENTS: 'TMReblogsWComments',
  TM_REBLOGS_WO_COMMENTS: 'TMReblogsWOComments',
  TW_INFORMAL_REPLIES: 'TWInformalReplies',
  TW_QUOTE: 'TWQuote',
  ORIGINAL: 'Original',
  REPOST: 'Repost',
  REPLY: 'Reply',
  COMMENT: 'Comment',
  YT_POST: 'YTPost',
  YT_COMMENT: 'YTComment',
  MO_ORIGINAL: 'MOOriginal',
  MO_REPOST: 'MORepost'
})
export default ProsperoPostType
export type ProsperoPostTypeStrings = typeof ProsperoPostType[keyof typeof ProsperoPostType]
// RESERVE BELOW
